/*
 * パイオニア・システム Shopify/Huckleberry 定期便購入条件制御
 * 対象商品は1箱からカートへ追加可能。
 * 同じ配送周期の対象定期購入商品を合算し、合計2箱以上で購入可能。
 *
 * 注意：テーマJavaScriptによる通常導線の制御です。
 * JavaScriptを経由しないCart APIへの直接通信などを完全には防げません。
 */
(function (window, document) {
  'use strict';

  const DEFAULTS = {
    targetProductIds: [8027915714714, 8027915124890, 7849507225754, 7850750050458],
    subscriptionMinimum: 2,
    regularMinimum: 1,
    cartEndpoint: '/cart.js',
    debounceMs: 100,
    debug: false
  };

  const CONFIG = Object.assign({}, DEFAULTS, window.PIONEER_SUBSCRIPTION_MIN_QTY || {});
  CONFIG.targetProductIds = (CONFIG.targetProductIds || DEFAULTS.targetProductIds)
    .map(Number)
    .filter(Number.isFinite);

  let cartTimer = null;
  let cartRequest = null;
  let observer = null;
  let variantRestoreToken = 0;
  let variantRestoreTimers = [];

  function log() {
    if (CONFIG.debug && window.console) {
      window.console.log('[subscription-cart-minimum]', ...arguments);
    }
  }

  function isTargetProductId(productId) {
    return CONFIG.targetProductIds.includes(Number(productId));
  }

  function currentProductId() {
    const candidates = [
      window.meta && window.meta.product && window.meta.product.id,
      window.ShopifyAnalytics && window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.id,
      document.body && document.body.dataset && document.body.dataset.productId
    ];
    for (const candidate of candidates) {
      if (candidate != null && Number.isFinite(Number(candidate))) return Number(candidate);
    }
    return null;
  }

  function capturePurchaseSelection() {
    const subscription = document.querySelector('#subscription');
    if (!subscription || !subscription.checked) {
      return { subscription: false, sellingPlan: null };
    }

    const selectedPlan = document.querySelector('input[name="planOption"]:checked');
    const hiddenPlan = productForms()
      .map((form) => form.querySelector('input[name="selling_plan"]'))
      .find((input) => input && String(input.value || '').trim());

    return {
      subscription: true,
      sellingPlan: String(selectedPlan?.value || hiddenPlan?.value || '')
    };
  }

  function restorePurchaseSelection(snapshot, token) {
    if (token !== variantRestoreToken || !snapshot.subscription) return;
    const productId = currentProductId();
    if (productId == null || !isTargetProductId(productId)) return;

    const subscription = document.querySelector('#subscription');
    if (!subscription) return;
    if (!subscription.checked) subscription.click();

    if (snapshot.sellingPlan) {
      const plan = Array.from(document.querySelectorAll('input[name="planOption"]'))
        .find((input) => String(input.value) === snapshot.sellingPlan);
      if (plan && !plan.checked) plan.click();
    }

    enforceProductPage();
  }

  function scheduleVariantPurchaseRestore(snapshot) {
    variantRestoreTimers.forEach(window.clearTimeout);
    const token = ++variantRestoreToken;
    variantRestoreTimers = [0, 80, 200, 450, 800, 1400].map((delay) =>
      window.setTimeout(function () {
        restorePurchaseSelection(snapshot, token);
      }, delay)
    );
  }

  function productForms() {
    return Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
  }

  function productQuantityInputs() {
    const inForms = productForms().flatMap((form) =>
      Array.from(form.querySelectorAll('input[name="quantity"]'))
    );
    return inForms.length
      ? Array.from(new Set(inForms))
      : Array.from(document.querySelectorAll('input[name="quantity"]'));
  }

  function enforceProductPage() {
    const productId = currentProductId();
    if (productId == null || !isTargetProductId(productId)) return false;
    productQuantityInputs().forEach((input) => {
      input.min = String(CONFIG.regularMinimum);
      const quantity = Number.parseInt(String(input.value), 10);
      if (!Number.isFinite(quantity) || quantity < CONFIG.regularMinimum) {
        input.value = String(CONFIG.regularMinimum);
        input.dispatchEvent(new window.Event('input', { bubbles: true }));
        input.dispatchEvent(new window.Event('change', { bubbles: true }));
      }
    });
    renderProductNotice();
    return true;
  }

  function renderProductNotice() {
    if (document.querySelector('[data-pioneer-subscription-product-notice]')) return;
    const form = productForms()[0];
    if (!form) return;
    const notice = document.createElement('p');
    notice.setAttribute('data-pioneer-subscription-product-notice', '');
    notice.textContent = '定期購入は、対象商品を自由に組み合わせて、同じ配送周期で合計2箱以上からご利用いただけます。';
    notice.style.cssText = 'margin:12px 0;color:#333;font-size:14px;line-height:1.7;';
    const quantity = form.querySelector('quantity-input, .product-form__quantity, input[name="quantity"]');
    const anchor = quantity && (quantity.closest('.product-form__input') || quantity.parentElement);
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(notice, anchor.nextSibling);
    else form.insertBefore(notice, form.firstChild);
  }

  function planCycle(item) {
    const plan = item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    if (!plan) return null;
    const optionValues = Array.isArray(plan.options)
      ? plan.options.map((option) => String(option.value || '').trim()).filter(Boolean)
      : [];
    const raw = optionValues.join(' / ') || String(plan.name || '').trim() || String(plan.id || 'subscription');
    const normalized = raw
      .replace(/\s+/g, '')
      .replace(/[０-９]/g, (character) => String.fromCharCode(character.charCodeAt(0) - 65248))
      .toLowerCase();
    return { key: normalized, label: raw };
  }

  function subscriptionGroups(cart) {
    const groups = new Map();
    if (!cart || !Array.isArray(cart.items)) return [];
    cart.items.forEach((item) => {
      if (!isTargetProductId(item.product_id) || !item.selling_plan_allocation) return;
      const cycle = planCycle(item);
      if (!cycle) return;
      if (!groups.has(cycle.key)) groups.set(cycle.key, { key: cycle.key, label: cycle.label, quantity: 0 });
      groups.get(cycle.key).quantity += Number(item.quantity) || 0;
    });
    return Array.from(groups.values());
  }

  function checkoutControls() {
    return Array.from(new Set(Array.from(document.querySelectorAll(
      'button[name="checkout"], input[name="checkout"], [href="/checkout"], [data-checkout-button]'
    ))));
  }

  function warningMessage(invalidGroups) {
    if (!invalidGroups.length) return '';
    const details = invalidGroups.map((group) => {
      const shortage = Math.max(CONFIG.subscriptionMinimum - group.quantity, 0);
      return group.label + 'はあと' + shortage + '箱お選びください。';
    });
    return '定期購入は、同じ配送周期の商品を合計2箱以上からご購入いただけます。' + details.join(' ');
  }

  function renderCartState(cart) {
    const invalidGroups = subscriptionGroups(cart).filter((group) => group.quantity < CONFIG.subscriptionMinimum);
    const invalid = invalidGroups.length > 0;
    const message = warningMessage(invalidGroups);
    const controls = checkoutControls();

    controls.forEach((control) => {
      const parent = control.parentElement || control;
      const parentDisplay = window.getComputedStyle(parent).display;
      const parentIsLayoutRow = parentDisplay === 'flex' || parentDisplay === 'inline-flex' || parentDisplay === 'grid';
      const host = parentIsLayoutRow && parent.parentElement ? parent.parentElement : parent;
      let notice = host.querySelector(':scope > [data-pioneer-subscription-cart-warning]');
      if (!notice) {
        notice = document.createElement('div');
        notice.setAttribute('data-pioneer-subscription-cart-warning', '');
        notice.setAttribute('role', 'alert');
        notice.style.cssText = 'display:none;width:100%;box-sizing:border-box;margin:0 0 12px;padding:12px 14px;border:1px solid #c53b2c;background:#fff5f3;color:#8a2117;font-size:14px;line-height:1.65;text-align:left;';
        if (parentIsLayoutRow) host.insertBefore(notice, parent);
        else host.insertBefore(notice, control);
      }
      notice.innerHTML = invalid
        ? '<strong>あと1箱お選びください。</strong><br>' + escapeHtml(message) + '<br><a href="/collections/all" style="color:inherit;text-decoration:underline;">商品を追加する</a>'
        : '';
      notice.style.display = invalid ? 'block' : 'none';

      if (invalid) {
        control.setAttribute('aria-disabled', 'true');
        control.classList.add('pioneer-subscription-checkout-disabled');
        if ('disabled' in control) control.disabled = true;
        control.style.pointerEvents = 'none';
        control.style.opacity = '0.5';
      } else {
        control.removeAttribute('aria-disabled');
        control.removeAttribute('disabled');
        control.classList.remove('pioneer-subscription-checkout-disabled');
        delete control.dataset.pioneerOriginalAriaDisabled;
        if ('disabled' in control) control.disabled = false;
        control.style.pointerEvents = '';
        control.style.opacity = '';
      }
    });

    document.documentElement.toggleAttribute('data-pioneer-subscription-cart-invalid', invalid);
    document.dispatchEvent(new window.CustomEvent('pioneer:subscription-cart-validated', {
      detail: { valid: !invalid, invalidGroups: invalidGroups, cart: cart }
    }));
    return !invalid;
  }

  function escapeHtml(value) {
    const element = document.createElement('div');
    element.textContent = String(value);
    return element.innerHTML;
  }

  async function readCart() {
    const response = await window.fetch(CONFIG.cartEndpoint, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('カート取得に失敗しました: ' + response.status);
    return response.json();
  }

  async function validateCart() {
    if (cartRequest) return cartRequest;
    cartRequest = (async function () {
      try {
        const cart = await readCart();
        renderCartState(cart);
        return cart;
      } catch (error) {
        log(error);
        return null;
      } finally {
        cartRequest = null;
      }
    })();
    return cartRequest;
  }

  function scheduleCartValidation() {
    window.clearTimeout(cartTimer);
    cartTimer = window.setTimeout(validateCart, CONFIG.debounceMs);
  }

  function onChange(event) {
    if (
      event.target.matches('variant-selects select, variant-radios input, .product-form__input input[type="radio"]') &&
      !event.target.matches('#subscription, #onetime, input[name="planOption"]')
    ) {
      scheduleVariantPurchaseRestore(capturePurchaseSelection());
    }

    if (event.target.matches('#subscription, #onetime, input[name="planOption"], input[name="selling_plan"], input[name="quantity"]')) {
      window.setTimeout(enforceProductPage, 0);
    }
    if (event.target.matches('input[name="updates[]"], input[name="quantity"]')) {
      scheduleCartValidation();
    }
  }

  function onClick(event) {
    if (event.target.closest('button[name="minus"], button[name="plus"], #subscription, #onetime, [data-cart-remove]')) {
      window.setTimeout(enforceProductPage, 0);
      scheduleCartValidation();
    }
  }

  async function onSubmit(event) {
    const form = event.target;
    const submitter = event.submitter;
    const checkout = submitter && submitter.name === 'checkout';
    if (!checkout || form.dataset.pioneerCheckoutSubmitting === '1') return;

    event.preventDefault();
    const cart = await validateCart();
    if (!cart) {
      window.alert('数量を確認できませんでした。ページを再読み込みして、もう一度お試しください。');
      return;
    }
    const valid = subscriptionGroups(cart).every((group) => group.quantity >= CONFIG.subscriptionMinimum);
    if (!valid) {
      renderCartState(cart);
      const warning = document.querySelector('[data-pioneer-subscription-cart-warning]');
      if (warning) warning.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    form.dataset.pioneerCheckoutSubmitting = '1';
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(submitter);
    } else {
      const checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'checkout';
      form.appendChild(checkoutInput);
      window.HTMLFormElement.prototype.submit.call(form);
    }

    window.setTimeout(function () {
      delete form.dataset.pioneerCheckoutSubmitting;
    }, 3000);
  }

  function startObserver() {
    if (!window.MutationObserver || observer) return;
    observer = new window.MutationObserver(function (mutations) {
      const relevant = mutations.some((mutation) => {
        const target = mutation.target && mutation.target.nodeType === 1
          ? mutation.target
          : mutation.target && mutation.target.parentElement;
        return !target || !target.closest('[data-pioneer-subscription-cart-warning], [data-pioneer-subscription-product-notice]');
      });
      if (!relevant) return;
      enforceProductPage();
      scheduleCartValidation();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() {
    document.addEventListener('change', onChange, true);
    document.addEventListener('click', onClick, true);
    document.addEventListener('submit', onSubmit, true);
    enforceProductPage();
    scheduleCartValidation();
    startObserver();
  }

  window.PioneerSubscriptionMinQuantity = {
    config: CONFIG,
    enforceProductPage: enforceProductPage,
    validateCart: validateCart,
    renderCartState: renderCartState,
    subscriptionGroups: subscriptionGroups,
    isTargetProductId: isTargetProductId
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})(window, document);
